import { render } from "./pageDataPrivacy.vue?vue&type=template&id=28bf1533&scoped=true"
const script = {}

import "./pageDataPrivacy.vue?vue&type=style&index=0&id=28bf1533&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bf1533"]])

export default __exports__